export const iconFontAwesomeBuildingsSchoolLock = (
	<i className="fa-solid fa-school-lock"></i>
);
